import type { HtmlAttributes } from '@studio/design-system/props';
import type { Device } from '@studio/models/device';

/** Video `<Badge>` properties. */
export type Props = HtmlAttributes<{
  badgeStatus?: BadgeStatus;
  deviceId: Device['id'];
  calibrationProgress?: number | undefined;
  /** Wrap informational copy onto more lines when the host is narrower than the message. */
  wrap?: boolean;
  /**
   * Gate the badge's action while it is in flight (e.g. a Configuration badge whose
   * action has been triggered). Forwarded to the design-system badge, which then
   * neither fires its action nor selects the parent tile and leaves the tab order.
   */
  disabled?: boolean;
}>;

/** Video `<Badge>` properties. */
export enum BadgeStatus {
  BADGE_STATUS_CONNECTING = 1,
  BADGE_STATUS_CONNECTED = 2,

  BADGE_STATUS_MOVEMENT_CONNECTING = 3,
  BADGE_STATUS_VIDEO_CONNECTING = 4,
  BADGE_STATUS_AUDIO_CONNECTING = 5,

  BADGE_STATUS_MOVEMENT_CONNECTION_FAILED = 6,
  BADGE_STATUS_VIDEO_CONNECTION_FAILED = 7,
  BADGE_STATUS_AUDIO_CONNECTION_FAILED = 8,

  BADGE_STATUS_BOOTING = 9,
  BADGE_STATUS_SHUTTING_DOWN = 10,
  BADGE_STATUS_REBOOTING = 11,
  BADGE_STATUS_IDLE = 12,

  BADGE_STATUS_CALIBRATING = 13,
  BADGE_STATUS_CALIBRATION_FAILED = 14,
  BADGE_STATUS_CALIBRATION_SUCCEEDED = 15,
  BADGE_STATUS_CALIBRATION_GENERIC = 16,

  BADGE_STATUS_BRIDGE_OFFLINE = 17,

  // ENG-3716 — terminal states for the waiting-for-video-track state machine
  // (livekit/track-wait.ts). Each carries actionable copy keyed to the cause,
  // replacing the old unbounded "Connecting..." dead end.
  BADGE_STATUS_VIDEO_CAMERA_UNREACHABLE = 18,
  BADGE_STATUS_VIDEO_STREAM_INTERRUPTED = 19,
  BADGE_STATUS_VIDEO_DEVICE_NOT_DISCOVERED = 20,
  BADGE_STATUS_VIDEO_FORMAT_UNSUPPORTED = 21,
  BADGE_STATUS_VIDEO_H265_UNSUPPORTED = 22
}
